import { FC, ReactNode, useEffect } from "react";
import { Layout, Typography, Space } from "antd";
import { Link, useLocation } from "react-router-dom";
import { SERVICE_TITLE } from "@shared/config/service-config";
import { PublicHeader } from "./PublicHeader";
import "../../styles/public-buttons.css";
import "../../styles/new-landing.css";

const { Content, Footer } = Layout;
const { Title, Paragraph } = Typography;

interface PublicPageLayoutProps {
  title?: string;
  subtitle?: ReactNode;
  children: ReactNode;
}

export const PublicPageLayout: FC<PublicPageLayoutProps> = ({ title, subtitle, children }) => {
  const location = useLocation();

  // ページ遷移時にスクロールをトップに戻す
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <Layout style={{ minHeight: "100vh", background: "#fff" }}>
      <PublicHeader />

      <Content className="public-page-content">
        <div className="public-page-inner">
          {(title || subtitle) && (
            <header style={{ marginBottom: 32 }}>
              {title && (
                <Title level={1} style={{ marginBottom: 16, fontSize: 'clamp(24px, 5vw, 32px)' }}>
                  {title}
                </Title>
              )}
              {subtitle && (
                <Paragraph style={{ fontSize: 16, color: "#595959", marginBottom: 0 }}>{subtitle}</Paragraph>
              )}
            </header>
          )}

          <main>{children}</main>
        </div>
      </Content>

      <Footer className="public-footer">
        <Space direction="vertical" size="middle" style={{ width: "100%" }}>
          <Space wrap size={[16, 8]} style={{ justifyContent: 'center' }}>
            <a href="https://dio-meta.com/company" target="_blank" rel="noopener noreferrer">
              会社概要
            </a>
            <Link to="/service/features">機能紹介</Link>
            <Link to="/service/plans">料金プラン</Link>
            <Link to="/industry-guides">業界別デモ</Link>
            <Link to="/contact">お問い合わせ</Link>
            <Link to="/legal/terms-privacy">利用規約</Link>
            <a href="https://dio-meta.com/privacypolicy/" target="_blank" rel="noopener noreferrer">
              プライバシーポリシー
            </a>
            <Link to="/legal/specified-commercial-transactions">特定商取引法</Link>
          </Space>
          <Paragraph style={{ marginBottom: 0, color: "#8c8c8c", fontSize: 13 }}>
            © 2025 {SERVICE_TITLE}. All rights reserved. powered by AVS1866
          </Paragraph>
        </Space>
      </Footer>
    </Layout>
  );
};

export default PublicPageLayout;


